module.exports = "../dist/img/white-37.8f3f.jpg";